import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import FieldExpenseCategory_PopoverMenuMore from "./components/popover/popover-menu-more"
import {FieldFilterType} from "../../../proto/types"
// import FieldExpenseCategory_ConditionForm from "./render/_old_to_delete-condition"

// const debug = "FieldExpenseCategory"
const debug = false

export default class FieldExpenseCategory extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Expense type"

        this.noValueOption      = false
        this.placeholder        = 'Please select'
        this.filterType         = FieldFilterType.DROPDOWN_DYNAMIC

        this.showMenuMore       = gd.ac.check.company.isManager()

        // da imenno tak tut nado.... - pochemu ????
        if (this.showMenuMore) {
            this.components.PopoverMenuMore = FieldExpenseCategory_PopoverMenuMore
        } else {
            this.components.PopoverMenuMore = false
        }

        // this.renderComponents.conditionForm = FieldExpenseCategory_ConditionForm
        // this.renderComponents.filterForm    = FieldExpenseCategory_ConditionForm
    }

    // i daze deleted (!)
    getOptions() {
        return gd.session.expenseCategories.toOptions()
    }

    // mega vazno !
    getOptionsForEdit(model:any):any[] {
        debug && console.log(debug, 'getOptionsForEdit', gd.session.expenseCategories)
        return gd.session.expenseCategories.activeToOptions()
    }

    //
    /*public getFilterOptions(optionsSet?:Set<any>):Option[] {

        const expenseCategoryIds : ID[] = [...optionsSet!]

        const result : Option[] = []

        _.map(expenseCategoryIds, (categoryId:ID)=>{
            const expenseCategory = gd.session.expenseCategories.get(categoryId)
            if (expenseCategory) {
                result.push(expenseCategory.toOption())
            }
        })

        return result
    }*/
}
